import React from "react";
import {
    assetDataImport,
    getResource,
    getResourceForImport,
    organisationDataRemove
} from "../../appRedux/actions/Organisation";
import { connect } from "react-redux";
import { Button, Card, Checkbox, Form, Input, Select, Spin } from "antd";
import { faviconDynamicFunction } from "../../util/methods";

class RemoveOrganisationData extends React.Component {
    state = {
        file: {},
        isForRemove: false,
    }
    createResource = (values) => {
        this.props.createResource(values);
    };

    componentDidMount() {
        this.props.getResourceForImport();
    }

    onSubmitRemoveData = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            if (values.organisation) {
                this.props.organisationDataRemove({
                    organisation: values.organisation,
                    isRemove: this.state.isForRemove
                });
            }
            this.props.form.resetFields();
        });
    }

    onFileChange = e => {
        this.setState({ file: e.target.files[0] });
    }

    onCheckChange = e => {
        console.log('checked = ', e.target.checked);
        this.setState({ isForRemove: !this.state.isForRemove });
    };

    render() {
        const { match, resource, loading, authUser, resourceName, data, importData } = this.props;
        faviconDynamicFunction(authUser);
        const { getFieldDecorator } = this.props.form;
        // console.log(importData);
        return (
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`}>
                    <h2>Asset Data Import</h2>
                    <div style={{ marginTop: '30px', marginLeft: '2%', width: '50%' }}>
                        <Form onSubmit={this.onSubmitRemoveData}>
                            <Form.Item label="Select Organisation">
                                {getFieldDecorator("organisation", {
                                    rules: [{ required: true, message: `Organisation is required!` }],
                                })(
                                    <Select
                                        mode='single'
                                        showSearch
                                        allowClear
                                        placeholder={'Select Organisation'}
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.props && this.props.data && this.props.data.length && this.props.data.map(org =>
                                            <Select.Option key={org._id} value={org._id}>{org.name}</Select.Option>
                                        )}
                                    </Select>)}
                            </Form.Item>


                            <Checkbox
                                checked={this.state.isForRemove}
                                onChange={this.onCheckChange}
                            >
                                Confirm Remove organisation data
                            </Checkbox>

                            <Form.Item>
                                <Button
                                    disabled={!this.state.isForRemove}
                                    type="danger"
                                    className="gx-mb-0"
                                    htmlType="submit"
                                    loading={loading}
                                >Remove Data
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
            </Spin>)
    }
}

const mapStateToProps = ({ commonData, auth, organisation }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        modules: commonData.modules,
        data: organisation.resources,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getResource,
        organisationDataRemove,
        getResourceForImport,
    };
}

RemoveOrganisationData = connect(mapStateToProps, mapDispatchToProps())(RemoveOrganisationData);
export default Form.create({ name: 'upload' })(RemoveOrganisationData);


